import { useEffect, useState } from 'react';

/**
 * Debounces a fast-changing value (e.g. a text input).
 * Returns the latest value only after `delay` ms have passed without further changes.
 */
export const useDebounce = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};
